import { createSelector } from 'reselect';

export const selectDemTemplates = createSelector(
  (state) => state.DemTemplate.demTemplates,
  (demTemplates) => demTemplates,
);

export const selectDemTemplateById = (id) =>
  createSelector(
    (state) => state.DemTemplate.demTemplates,
    (demTemplates) => {
      if (!id) return null;
      return demTemplates.find((t) => t.id === id) || null;
    },
  );

export const selectSelectedDemTemplate = createSelector(
  (state) => state.DemTemplate.selectedTemplate,
  (selectedTemplate) => selectedTemplate,
);

export const selectDemTemplatesLoading = createSelector(
  (state) => state.DemTemplate.loading,
  (loading) => loading,
);

export const selectAiPanelOpen = createSelector(
  (state) => state.DemTemplate.ai,
  (ai) => ai.isOpen,
);

export const selectAiMessages = createSelector(
  (state) => state.DemTemplate.ai,
  (ai) => ai.messages,
);

export const selectAiLoading = createSelector(
  (state) => state.DemTemplate.ai,
  (ai) => ai.loading,
);

export const selectAiError = createSelector(
  (state) => state.DemTemplate.ai,
  (ai) => ai.error,
);
